const isDev = !process.env.REACT_APP_NODE_ENV;

type LogLevel = 'error' | 'warn' | 'info' | 'debug';

function toMessage(args: unknown[]): string {
	return args
		.filter((a) => !(a instanceof Error))
		.map((a) => (typeof a === 'string' ? a : JSON.stringify(a)))
		.join(' ');
}

function getError(args: unknown[]): Error | undefined {
	return args.find((a): a is Error => a instanceof Error);
}

function send(level: LogLevel, args: unknown[]): void {
	if (isDev) {
		(console[level] as (...a: unknown[]) => void)(...args);
		return;
	}

	// eslint-disable-next-line @typescript-eslint/no-var-requires
	const gc = require('@groundcover/browser');
	const err = getError(args);
	if (err) {
		gc.captureException(err);
	} else {
		gc.sendCustomEvent({ event: `log.${level}`, attributes: { message: toMessage(args) } });
	}
}

const logger = {
	error: (...args: unknown[]) => send('error', args),
	warn: (...args: unknown[]) => send('warn', args),
	info: (...args: unknown[]) => send('info', args),
	debug: (...args: unknown[]) => send('debug', args),
	log: (...args: unknown[]) => send('info', args),
};

export default logger;
